import style from "./style.module.scss";
import icon from "../../../img/modals/like.svg";
import {useStore} from "effector-react";
import {$store} from "../../../store";

const AllSuccess = (props:{onOk:Function}) => {

	const store = useStore($store);

	return (
		<div className={style.allSuccess}>
			<div className={style.icon}>
				<img src={icon} alt=""/>
			</div>
			<p className={style.title}>{store.app.dict?.successAll?.congratulations}</p>
			<p className={style.subtitle}>{store.app.dict?.successAll?.prediction_correct_you_receive_your_bonus_balance}</p>
			<p className={style.subtitleB}>{store.app.dict?.successAll?.good_luck}</p>
			<div className={style.buttons}>
				<div onClick={()=>{ props.onOk(); }} className={`${style.btn} ${style.btnA}`}>{store.app.dict?.successAll?.ok}</div>
			</div>
		</div>
	);
};

export default AllSuccess;
